module.exports = __webpack_public_path__ + "img/hyk.700af3a0.png";